import { Incentive } from "@/pages/incentive";
import { IncentiveReportPage } from "@/pages/incentive/report";

export const routeIncentive = "/incentive";
export const routeIncentiveReport = "/incentive/report";

export const incentiveRoutes = [
	{
		path: routeIncentive,
		element: <Incentive />,
		permission: "ui.navbar.mill.incentive",
	},
	{
		path: routeIncentiveReport,
		element: <IncentiveReportPage />,
		permission: "ui.navbar.mill.incentive.report",
	},
];
